import * as React from 'react'

import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { SafeHtml, Separator } from '@thg-commerce/gravity-elements'
import { spacing, styled, Text } from '@thg-commerce/gravity-theme'
import { Border } from '@thg-commerce/gravity-theme/border'

import { useProductPageSku } from '../../context'
import { useProductPage } from '../../context/ProductPageContext'

const PromotionalMessageContainer = styled.div<{
  messageBackgroundColor?: string
  border?: Border
}>`
  ${Text('bodyText', 'alternate')};
  padding: ${spacing(1)};
  background-color: ${(props) =>
    props.messageBackgroundColor || props.theme.colors.palette.greys.lighter};
  border-width: ${(props) => props.border?.width || '0px'};
  border-color: ${(props) => props.border?.color || 'transparent'};
  border-style: ${(props) => props.border?.style || 'solid'};
  img {
    max-width: 100%;
  }
`

const PRODUCT_MESSAGE_CONTENT_KEY = 'productMessage'

const hasProductMessage = (contentItem) =>
  contentItem.key === PRODUCT_MESSAGE_CONTENT_KEY &&
  contentItem.value.__typename === 'ProductContentRichContentValue'

interface PromotionalMessageInterface {
  warningKeywords?: string[]
}

export const PromotionalMessage = ({
  warningKeywords,
}: PromotionalMessageInterface) => {
  const { product, selectedVariant } = useProductPage()
  const { sku } = useProductPageSku()
  const theme = useTheme()
  const variantSku: number = selectedVariant?.sku
  let productMessageItem

  if (sku === variantSku) {
    productMessageItem = product?.content?.find(hasProductMessage)
  } else if (product?.variants) {
    productMessageItem = product.variants
      .find((variant) => variant.sku === variantSku)
      // TODO: optimise-product-css-accordion - reinstate type check
      ?.product?.content.find(hasProductMessage)
  }

  const promotionalMessage =
    productMessageItem?.value.richContentValue.content[0].content

  const useWarningStyles =
    promotionalMessage &&
    warningKeywords
      ?.map((keyword) =>
        promotionalMessage?.toLowerCase().includes(keyword?.toLowerCase()),
      )
      .includes(true) &&
    theme.pageTheme.promotionalMessage?.warningStyles

  if (!promotionalMessage) {
    return null
  }

  const styleProps = useWarningStyles
    ? {
        messageBackgroundColor:
          theme.pageTheme.promotionalMessage?.warningStyles?.backgroundColor,
        border: theme.pageTheme.promotionalMessage?.warningStyles?.border,
      }
    : {
        messageBackgroundColor:
          theme.pageTheme.promotionalMessage?.promotionalMessageBackground
            ?.backgroundColor,
      }

  return (
    <React.Fragment>
      <PromotionalMessageContainer {...styleProps}>
        <SafeHtml content={promotionalMessage} />
      </PromotionalMessageContainer>
      <Separator withSpacing />
    </React.Fragment>
  )
}
